import { useQuery } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

import { PROMPT_QUERY_MAP } from './utils/promptUtils';

const getQuery = (queryType) => PROMPT_QUERY_MAP[queryType] || PROMPT_QUERY_MAP.article;

function usePromptQuery({ promptSlug, queryType = 'smartAssist' }) {
  const { data, loading, error } = useQuery(getQuery(queryType), {
    variables: {
      input: { slug: promptSlug },
    },
    noThrow: true,
    useCache: true,
  });

  useError(error);
  return { error, data, loading };
}

export { usePromptQuery };
